module.exports = __webpack_public_path__ + "img/cloudways-hosting2.2722b31c.jpg";